/**
 * Returns a function that joins the given (truthy) strings using a specified separator.
 * Ignores falsy or whitespace-only strings.
 *
 * @param args - The strings to be joined. Falsy and whitespace-only strings are excluded.
 * @returns A function that takes a separator (defaults to ' | ') and returns the joined string.
 *
 * @example
 * const join = createStringJoiner('foo', 'bar', 'baz');
 * join(' | '); // 'foo | bar | baz'
 *
 * @example
 * const join = createStringJoiner('foo', undefined, 'baz');
 * join(', '); // 'foo, baz'
 */
export default function createStringJoiner(
  ...args: string[]
): (separator?: string) => string {
  return (separator: string = ' | ') => {
    return args.filter((str) => str?.trim()).join(separator)
  }
}
